var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseDialog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.41 8.99996L18.7 1.70996C18.8638 1.51865 18.9494 1.27258 18.9397 1.0209C18.93 0.769226 18.8257 0.530488 18.6476 0.352393C18.4695 0.174299 18.2307 0.0699657 17.9791 0.0602446C17.7274 0.0505234 17.4813 0.13613 17.29 0.299956L10 7.58996L2.71 0.289956C2.5187 0.12613 2.27263 0.0405241 2.02095 0.0502453C1.76927 0.0599665 1.53054 0.164298 1.35244 0.342393C1.17435 0.520487 1.07001 0.759226 1.06029 1.0109C1.05057 1.26258 1.13618 1.50865 1.3 1.69996L8.59 8.99996L1.29 16.29C1.18532 16.3796 1.1003 16.4899 1.04028 16.614C0.980255 16.7381 0.946525 16.8732 0.941205 17.0109C0.935886 17.1486 0.959092 17.286 1.00937 17.4143C1.05964 17.5426 1.1359 17.6592 1.23335 17.7566C1.33081 17.8541 1.44736 17.9303 1.57568 17.9806C1.70401 18.0309 1.84134 18.0541 1.97906 18.0488C2.11678 18.0434 2.25191 18.0097 2.37597 17.9497C2.50004 17.8897 2.61036 17.8046 2.7 17.7L10 10.41L17.29 17.7C17.4813 17.8638 17.7274 17.9494 17.9791 17.9397C18.2307 17.9299 18.4695 17.8256 18.6476 17.6475C18.8257 17.4694 18.93 17.2307 18.9397 16.979C18.9494 16.7273 18.8638 16.4813 18.7 16.29L11.41 8.99996Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseDialog);
export default __webpack_public_path__ + "static/media/closeDialog.72e457f5.svg";
export { ForwardRef as ReactComponent };